// Inline SVG Mativex mark — adapts to any background via currentColor + accent.
export default function Logo({ size = 36, withWordmark = false, className = "" }) {
  if (withWordmark) {
    // Horizontal layout: symbol on left, MATIVEX sans wordmark on right.
    return (
      <svg
        width={size}
        height={size * 0.22}
        viewBox="0 0 460 100"
        fill="none"
        className={className}
        aria-label="Mativex"
      >
        {/* === Symbol === */}
        <g transform="translate(8 18)">
          <rect x="0" y="36" width="4" height="22" fill="currentColor" />
          <rect x="7" y="28" width="4" height="30" fill="currentColor" />
          <rect x="14" y="20" width="4" height="38" fill="currentColor" />
          <path d="M38 4 L38 78 M32 12 L38 4 L44 12"
            stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M22 40 L82 40 M74 32 L82 40 L74 48"
            stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="22,52 28,52 33,18 39,68 45,30 51,52 70,52"
            fill="none" stroke="hsl(var(--primary))" strokeWidth="4.5"
            strokeLinejoin="round" strokeLinecap="round" />
        </g>
        {/* === Wordmark — geometric sans, heavy, wide-tracked === */}
        <g transform="translate(112 0)">
          <text
            x="0" y="72"
            fontFamily="'Manrope', 'Helvetica Neue', Arial, sans-serif"
            fontWeight="700"
            fontSize="60"
            letterSpacing="3"
            fill="currentColor"
          >
            MATIVE<tspan fill="hsl(var(--primary))">X</tspan>
          </text>
        </g>
      </svg>
    );
  }

  // === Symbol-only fallback ===
  return (
    <svg
      width={size} height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      aria-label="Mativex"
    >
      <rect x="6" y="36" width="3" height="14" fill="currentColor" />
      <rect x="11" y="30" width="3" height="20" fill="currentColor" />
      <rect x="16" y="24" width="3" height="26" fill="currentColor" />
      <path d="M32 8 L32 52 M28 12 L32 8 L36 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 32 L58 32 M54 28 L58 32 L54 36" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="22,40 27,40 31,18 35,50 39,28 44,40 56,40" fill="none" stroke="hsl(var(--primary))" strokeWidth="3.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
